module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/maimaifail.42fe9c94.png";